export default __webpack_public_path__ + "static/media/loading.cddf54a5.gif";